<template>
  <button
    type="button"
    :class="`btn btn-sm ${props.value ? 'btn-primary' : 'btn-default'}`"
    :disabled="disabled"
    @click="onClick"
  >
    {{ props.value ? labelOn : labelOff }}
  </button>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';

const { emit } = getCurrentInstance();

const props = defineProps({
  /** 권장: Vue onXxx 리스너 규칙과 충돌하지 않음 */
  textOn: {
    type: String,
    default: undefined,
  },
  textOff: {
    type: String,
    default: undefined,
  },
  /** 하위 호환 (CurtainItem 등) */
  onText: {
    type: String,
    default: undefined,
  },
  offText: {
    type: String,
    default: undefined,
  },
  value: {
    type: Boolean,
    required: true,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const labelOn = computed(() => props.textOn || props.onText || '켜짐');
const labelOff = computed(() => props.textOff || props.offText || '꺼짐');

const onClick = () => {
  if (props.disabled) return;
  emit('onValueChange', !props.value);
};
</script>
